module.exports = __webpack_public_path__ + "img/Avatar.f2fe84ef.svg";